import { AccountingErrorResponse, isAccountingError } from 'multirpc-sdk';
import { AxiosError, isAxiosError } from 'axios';

export const isAxiosAccountingError = (
  error: unknown,
): error is AxiosError<AccountingErrorResponse> =>
  isAxiosError<AccountingErrorResponse>(error) &&
  isAccountingError(error.response?.data.error);
